import React, { useEffect, useMemo, useState } from 'react';
import { Rule, Service } from '../../../../dtos/version.dto';
import { useStores } from '../../../store';
import { uniqBy } from 'lodash';
import { listCells } from '../inventory-utils';

interface ServiceRuleCellProps {
    serviceData: Service;
}

export const ServiceRuleCell: React.FC<ServiceRuleCellProps> = ({serviceData} ) => {
    const {fwVersionStore} = useStores();
    const [rules, setRules] = useState<Rule[]>([]);

    useEffect(() => {
        const serviceRules = fwVersionStore.selectedVersionRules
                .filter(rule => rule.service.services.some(service => service.includes(serviceData.id)));

        setRules(uniqBy([...serviceRules], 'id'));
    }, [serviceData]);

    return useMemo(() => listCells(rules, `service-rule`), [rules]);

};
